import AnimatedCounter from "./AnimatedCounter";
import { Users, BookOpen, Library, Award } from "lucide-react";
import { WEBSEITE_FAKTEN } from "@/config/webseiteFakten";

// Zahlen aus webseiteFakten.ts (Frage 293); keine Bewertung ohne Quelle (Frage 297).
const stats = [
  {
    icon: Users,
    value: WEBSEITE_FAKTEN.fachkraefte.gerundet,
    suffix: "+",
    label: "Fachkräfte",
    description: "Lernen mit MusiKonzept",
  },
  {
    icon: BookOpen,
    value: WEBSEITE_FAKTEN.lektionen.gerundet,
    suffix: "+",
    label: "Lektionen",
    description: "Videos, Audios & PDFs",
  },
  {
    icon: Library,
    value: WEBSEITE_FAKTEN.kurse.gerundet,
    suffix: "+",
    label: "Kurse",
    description: "Für Krippe, Kita und Grundschule",
  },
  {
    icon: Award,
    value: WEBSEITE_FAKTEN.gegruendet,
    prefix: "seit ",
    jahreszahl: true,
    label: "Erfahrung",
    description: "In der Musikpädagogik",
  },
];

const StatsSection = () => {
  return (
    <section className="py-16 relative overflow-hidden">
      {/* Gradient Background */}
      <div className="absolute inset-0 bg-gradient-to-r from-primary/10 via-accent/10 to-primary/10" />
      
      <div className="container mx-auto px-6 relative z-10">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 max-w-6xl mx-auto">
          {stats.map((stat, index) => (
            <div
              key={index}
              className="text-center space-y-3 animate-fade-in group"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              {/* Icon */}
              <div className="w-16 h-16 mx-auto rounded-2xl bg-gradient-to-br from-primary/20 to-accent/20 flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                <stat.icon className="w-8 h-8 text-primary" />
              </div>

              {/* Animated Number */}
              <div className="text-4xl md:text-5xl font-bold bg-gradient-to-r from-primary via-accent to-primary bg-clip-text text-transparent">
                {stat.jahreszahl ? (
                  // Eine Jahreszahl zählt nicht hoch (und trägt keinen Tausenderpunkt).
                  <span>{stat.prefix}{stat.value}</span>
                ) : (
                  <AnimatedCounter end={stat.value} suffix={stat.suffix} duration={2500} />
                )}
              </div>

              {/* Label */}
              <div>
                <p className="text-base md:text-lg font-semibold text-foreground">
                  {stat.label}
                </p>
                <p className="text-sm text-muted-foreground">
                  {stat.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatsSection;
